import React, { FC } from 'react'
import styled from 'styled-components'

type Props = {
  src: string
  width?: string
  height?: string
  ratio?: {
    x: number
    y: number
  }
  inPopup?: boolean
}
export const Iframe: FC<Props> = ({
  src,
  width = '100%',
  height = '100%',
  ratio = { x: 16, y: 9 },
  inPopup = false
}) => {
  return (
    <Wrapper ratio={ratio} inPopup={inPopup}>
      <iframe src={src} width={width} height={height} />
    </Wrapper>
  )
}

const Wrapper = styled.div<{ ratio: { x: number; y: number }; inPopup: boolean }>`
  position: relative;
  height: 0;
  padding-bottom: ${({ ratio }) => `${(ratio.y / ratio.x) * 100}%`};

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    border: none;
  }
`
